import i18n from "@/common/i18n";
import EmbedLayout from '@/layout/embedLayout';
const router = [{
  path: '/embed',
  component: EmbedLayout,
  meta: {
    auth: false,
    title: i18n.t("lang.k_007001"),
    name: 'embedLayout'
  },
  hidden: true,
  children: [{
    path: 'live/list',
    component: () => import('@/views/LiveModule/list'),
    meta: {
      title: i18n.t("lang.k_007002"),
      name: 'liveList'
    },
    hidden: true
  }, {
    path: 'live/edit',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007003"),
      name: 'liveCreate',
      webinarType: 'live'
    },
    hidden: true
  }, {
    path: 'live/edit/:id',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007004"),
      name: 'liveEdit',
      webinarType: 'live'
    },
    hidden: true
  }, {
    path: 'live/vodEdit/:id',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007005"),
      name: 'vodEdit',
      webinarType: 'vod'
    },
    hidden: true
  }, {
    path: 'live/vodEdit',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007006"),
      name: 'vodCreate',
      webinarType: 'vod'
    },
    hidden: true
  }, {
    path: 'live/timeEdit',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007007"),
      name: 'liveTimeCreate',
      webinarType: 'time'
    },
    hidden: true
  }, {
    path: 'live/timeEdit/:id',
    component: () => import('@/views/LiveModule/edit'),
    meta: {
      title: i18n.t("lang.k_007008"),
      name: 'liveTimeEdit',
      webinarType: 'time'
    },
    hidden: true
  }, {
    path: 'live/detail/:str(\\d+)',
    component: () => import('@/views/LiveModule/detail'),
    meta: {
      title: i18n.t("lang.k_007009"),
      name: 'liveDetail',
      webinarType: 'live'
    },
    hidden: true
  }, {
    path: 'live/viewerRules/:str(\\d+)',
    component: () => import('@/views/LiveModule/viewerRules'),
    meta: {
      title: i18n.t("lang.k_007010"),
      name: 'viewerRules'
    },
    hidden: true
  }, {
    path: 'live/roleInvitation/:str(\\d+)',
    component: () => import('@/views/LiveModule/roleInvitation'),
    meta: {
      title: i18n.t("lang.k_007011"),
      name: 'roleInvitation'
    },
    hidden: true
  }, {
    path: 'live/planFunction/:str(\\d+)',
    component: () => import('@/views/LiveModule/planFunction'),
    meta: {
      title: i18n.t("lang.k_007012"),
      name: 'planFunction'
    },
    hidden: true
  }, {
    path: 'live/virtual/:str(\\d+)',
    component: () => import('@/views/LiveModule/virtual'),
    meta: {
      title: i18n.t("lang.k_007013"),
      name: 'virtual'
    },
    hidden: true
  }, {
    path: 'live/warm/:str(\\d+)',
    component: () => import('@/views/LiveModule/warm'),
    meta: {
      title: i18n.t("lang.k_007014"),
      name: 'warm'
    },
    hidden: true
  }, {
    path: 'live/embedCard/:str(\\d+)',
    component: () => import('@/views/LiveModule/embedCard'),
    meta: {
      title: i18n.t("lang.k_007015"),
      name: 'embedCard'
    },
    hidden: true
  }, {
    path: 'live/livingSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/Brands/livingSetting'),
    meta: {
      title: i18n.t("lang.k_007016"),
      name: 'livingSetting'
    },
    hidden: true
  }, {
    path: 'live/safeScreenSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/Brands/safeScreenSet'),
    meta: {
      title: i18n.t("lang.k_007017"),
      name: 'safeScreenSet'
    },
    hidden: true
  }, {
    path: 'live/playerSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/Brands/playerSet'),
    meta: {
      title: i18n.t("lang.k_007018"),
      name: 'playerSet'
    },
    hidden: true
  }, {
    path: 'live/word/:str(\\d+)',
    component: () => import('@/views/MaterialModule/word'),
    meta: {
      title: i18n.t("lang.k_007019"),
      name: 'word'
    },
    hidden: true
  }, {
    path: 'live/videoSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/videoSet'),
    meta: {
      title: i18n.t("lang.k_007020"),
      name: 'videoSet'
    },
    hidden: true
  },
  {
    path: 'live/signInSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/signInSet'),
    meta: { title: '签到', name: 'signInSet' },
    hidden: true
  },
  {
    path: 'live/winnerList/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/winnerList'),
    meta: {
      title: i18n.t("lang.k_007021"),
      name: 'winnerList'
    },
    hidden: true
  }, {
    path: 'live/prizeList/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/prizeList'),
    meta: {
      title: i18n.t("lang.k_007022"),
      name: 'prizeList'
    },
    hidden: true
  }, {
    path: 'live/prizeSet/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/prizeSet'),
    meta: {
      title: i18n.t("lang.k_007023"),
      name: 'prizeCreat'
    },
    hidden: true
  }, {
    path: 'live/question/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/question'),
    meta: {
      title: i18n.t("lang.k_007024"),
      name: 'question'
    },
    hidden: true
  }, {
    path: 'live/addQuestion',
    component: () => import('@/views/LiveModule/MaterialSet/components/addQuestion'),
    meta: {
      title: i18n.t("lang.k_007025"),
      name: 'addQuestion'
    },
    hidden: true
  }, {
    path: 'live/exam/:str(\\d+)',
    component: () => import('@/views/LiveModule/Exam/main'),
    meta: {
      title: i18n.t("lang.k_007026"),
      name: 'exam'
    },
    hidden: true
  }, {
    path: 'live/addExam',
    component: () => import('@/views/LiveModule/Exam/components/addExam'),
    meta: {
      title: i18n.t("lang.k_007027"),
      name: 'addExam'
    },
    hidden: true
  }, {
    path: 'live/productSet/:str(\\d+)',
    component: () => import('@/views/MaterialModule/Products/index.vue'),
    meta: {
      title: i18n.t("lang.k_007028"),
      name: 'productSet'
    },
    hidden: true
  }, {
    path: 'live/couponData/:str(\\d+)',
    component: () => import('@/views/MaterialModule/Products/viewCoupon.vue'),
    meta: {
      title: i18n.t("lang.k_007029"),
      name: 'couponData'
    },
    hidden: true
  }, {
    path: 'live/pushCard/:str(\\d+)',
    component: () => import('@/views/LiveModule/PushCard/main'),
    meta: {
      title: i18n.t("lang.k_007030"),
      name: 'pushCard'
    },
    hidden: true
  }, {
    path: 'live/addPushCard',
    component: () => import('@/views/LiveModule/PushCard/components/addCard'),
    meta: {
      title: i18n.t("lang.k_007027"),
      name: 'addPushCard'
    },
    hidden: true
  }, {
    path: 'live/clickPushCard',
    component: () => import('@/views/LiveModule/PushCard/components/clickCard'),
    meta: {
      title: i18n.t("lang.k_007031"),
      name: 'clickPushCard'
    },
    hidden: true
  }, {
    path: 'live/gift/:str(\\d+)',
    component: () => import('@/views/LiveModule/MaterialSet/giftSet'),
    meta: {
      title: i18n.t("lang.k_007032"),
      name: 'gift'
    },
    hidden: true
  }, {
    // 列表
    path: 'live/InteractReward/:str(\\d+)',
    component: () => import('@/views/LiveModule/InteractReward/index.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007033"),
      name: 'InteractReward',
      activeMenu: '/live/list'
    },
    hidden: true
  }, {
    // 列表
    path: 'live/WatchReward/:str(\\d+)',
    component: () => import('@/views/LiveModule/WatchReward/index.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007034"),
      name: 'WatchReward',
      activeMenu: '/live/list'
    },
    hidden: true
  }, {
    // 列表
    path: 'live/CashPacket/:str(\\d+)',
    component: () => import('@/views/LiveModule/CashPacket/list.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007035"),
      name: 'CashPacket',
      activeMenu: '/live/list'
    },
    hidden: true
  }, {
    // 创建、编辑、复制共用
    path: 'live/InteractiveRewardSetting/:str(\\d+)',
    component: () => import('@/views/LiveModule/InteractReward/setting/index.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007033"),
      name: 'InteractiveRewardSetting',
      activeMenu: '/live/list'
    },
    hidden: true
  }, {
    // 领奖用户列表
    path: 'live/InteractiveRewardUserList/:str(\\d+)',
    component: () => import('@/views/LiveModule/InteractReward/UserList.vue'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007033"),
      name: 'InteractiveRewardUserList',
      activeMenu: '/live/list'
    },
    hidden: true
  }, {
    path: 'live/playback/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/list'),
    meta: {
      title: i18n.t("lang.k_007036"),
      name: 'playback'
    },
    hidden: true
  }, {
    path: 'live/playback/:str(\\d+)/group/:switch_id(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/groupList'),
    meta: {
      title: i18n.t("lang.k_007037"),
      name: 'playbackGroupList'
    },
    hidden: true
  }, {
    path: 'live/recordplayback/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/list'),
    meta: {
      title: i18n.t("lang.k_007038"),
      name: 'recordplayback'
    },
    hidden: true
  }, {
    path: 'live/publishplayback/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/list'),
    meta: {
      title: i18n.t("lang.k_007039"),
      name: 'publishplayback'
    },
    hidden: true
  }, {
    path: 'live/vodreset/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/vodreset'),
    meta: {
      title: i18n.t("lang.k_007040"),
      name: 'vodreset'
    },
    hidden: true
  }, {
    path: 'live/reportsData/:str(\\d+)',
    component: () => import('@/views/LiveModule/Data/reportsData'),
    meta: {
      title: i18n.t("lang.k_007041"),
      name: 'reportsData'
    },
    hidden: true
  }, {
    path: 'live/interactionData/:str(\\d+)',
    component: () => import('@/views/LiveModule/Data/interactData'),
    meta: {
      title: i18n.t("lang.k_007042"),
      name: 'interactionData'
    },
    hidden: true
  }, {
    path: 'live/userData/:str(\\d+)',
    component: () => import('@/views/LiveModule/Data/userData'),
    meta: {
      title: i18n.t("lang.k_007043"),
      name: 'userData'
    },
    hidden: true
  }, {
    path: 'live/interactionDetail',
    component: () => import('@/views/LiveModule/Data/interactDetail'),
    meta: {
      title: i18n.t("lang.k_007044"),
      name: 'interactionDetail'
    },
    hidden: true
  }, {
    path: 'live/interactionDetail/invitedDataInfo',
    component: () => import('@/views/LiveModule/Data/invitedDataInfo'),
    meta: {
      title: i18n.t("lang.k_007045"),
      name: 'invitedDataInfo'
    },
    hidden: true
  }, {
    path: 'live/lookSingleQuestion/:str(\\d+)',
    component: () => import('@/views/LiveModule/Data/lookSingleQuestion'),
    meta: {
      title: i18n.t("lang.k_007046"),
      name: 'lookSingleQuestion'
    },
    hidden: true
  }, {
    path: 'live/lookSingleExam/:str(\\d+)',
    component: () => import('@/views/LiveModule/Data/lookSingleExam'),
    meta: {
      title: i18n.t("lang.k_007047"),
      name: 'lookSingleExam'
    },
    hidden: true
  },
  //互动
  {
    path: 'interactive/products',
    component: () => import('@/views/MaterialModule/Products/index'),
    meta: {
      title: i18n.t("lang.k_007028"),
      name: 'products'
    },
    hidden: true
  }, {
    path: 'interactive/addProduct',
    component: () => import('@/views/MaterialModule/Products/create'),
    meta: {
      title: i18n.t("lang.k_007048"),
      name: 'createproducts'
    },
    hidden: true
  }, {
    path: 'interactive/addCoupon',
    component: () => import('@/views/MaterialModule/Products/createCoupon'),
    meta: {
      title: i18n.t("lang.k_007049"),
      name: 'createCoupon'
    },
    hidden: true
  }, {
    path: 'interactive/addProduct/:goods_id',
    component: () => import('@/views/MaterialModule/Products/create'),
    meta: {
      title: i18n.t("lang.k_007050"),
      name: 'editproducts'
    },
    hidden: true
  }, {
    path: 'interactive/editCoupon/:couponId',
    component: () => import('@/views/MaterialModule/Products/createCoupon'),
    meta: {
      title: i18n.t("lang.k_007051"),
      name: 'editCoupon'
    },
    hidden: true
  }, {
    path: 'interactive/viewCoupon/:couponId',
    component: () => import('@/views/MaterialModule/Products/viewCoupon'),
    meta: {
      title: i18n.t("lang.k_007028"),
      name: 'viewCoupon'
    },
    hidden: true
  }, {
    path: 'interactive/copyCoupon/:couponId',
    component: () => import('@/views/MaterialModule/Products/createCoupon'),
    meta: {
      title: i18n.t("lang.k_007052"),
      name: 'copyCoupon'
    },
    hidden: true
  }, {
    path: 'live/AI/chat/list/:id(\\d+)',
    component: () => import('@/views/AIModule/chat/list'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007053"),
      name: 'AIChatListLive'
    },
    hidden: true
  }, {
    path: 'live/AI/chat/create',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007027"),
      name: 'AIChatCreateLive'
    },
    hidden: true
  }, {
    path: 'live/AI/chat/edit/:id(\\d+)',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: i18n.t("lang.k_007054"),
      name: 'AIChatEditLive'
    },
    hidden: true
  }]
}, {
  path: '/embed/live/videoTailoring/:str(\\d+)',
  component: () => import('@/views/LiveModule/PlayBack/videoTailoring'),
  meta: {
    auth: true,
    title: '',
    name: 'videoTailoring'
  },
  hidden: true
}];
export default router;